import { render, staticRenderFns } from "./SaToggle.vue?vue&type=template&id=45753621&"
import script from "./SaToggle.vue?vue&type=script&lang=js&"
export * from "./SaToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports